/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type featuredStorySection_home$ref: FragmentReference;
export type featuredStorySection_home = {|
  +featuredStory: {|
    +slug: ?string,
    +title: ?string,
    +caption: ?string,
    +widePicture: ?string,
    +picture: ?string,
    +videoLink: ?string,
    +city: ?{|
      +slug: string,
      +name: string,
      +color: ?string,
    |},
    +category: ?{|
      +slug: ?string,
      +name: ?string,
      +color: ?string,
    |},
  |},
  +$refType: featuredStorySection_home$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v1 = [
  v0,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "color",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "featuredStorySection_home",
  "type": "Home",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "featuredStory",
      "storageKey": null,
      "args": null,
      "concreteType": "Article",
      "plural": false,
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "caption",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "widePicture",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "picture",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "videoLink",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "city",
          "storageKey": null,
          "args": null,
          "concreteType": "City",
          "plural": false,
          "selections": v1
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "category",
          "storageKey": null,
          "args": null,
          "concreteType": "Category",
          "plural": false,
          "selections": v1
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f10a20e23e7fe445b6b516f391f4119f';
module.exports = node;
